import CommonResponse from "../../models/CommonResponse";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function setServerRunningValues(client: BackendClient, debugFlag: boolean): Promise<CommonResponse> {
  const headers = {
    'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
  };

  return new Promise<CommonResponse>((resolve, reject) => {
    axios.post(`${client.getBackendUrl()}${BackendClient.SetServerRunningValues}`, {debugFlag: debugFlag}, {headers: headers})
      .then((response) => resolve(response.data))
      .catch((reason) => {
        console.log(`Exception when trying to set running values: ${JSON.stringify(reason)}`)
        reject(reason);
      });
  });
}